/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_VaultInputs */

const en_go_to_vault = /** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Vault`)
};

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const es_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const fr_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const de_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const ja_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const zh_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const ar_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const id_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const it_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const ru_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const pt_go_to_vault = en_go_to_vault;

/** @type {(inputs: Go_To_VaultInputs) => LocalizedString} */
const ko_go_to_vault = en_go_to_vault;

/**
* | output |
* | --- |
* | "Go to Vault" |
*
* @param {Go_To_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const go_to_vault = /** @type {((inputs?: Go_To_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_to_vault(inputs)
	if (locale === "es") return es_go_to_vault(inputs)
	if (locale === "fr") return fr_go_to_vault(inputs)
	if (locale === "de") return de_go_to_vault(inputs)
	if (locale === "ja") return ja_go_to_vault(inputs)
	if (locale === "zh") return zh_go_to_vault(inputs)
	if (locale === "ar") return ar_go_to_vault(inputs)
	if (locale === "id") return id_go_to_vault(inputs)
	if (locale === "it") return it_go_to_vault(inputs)
	if (locale === "ru") return ru_go_to_vault(inputs)
	if (locale === "pt") return pt_go_to_vault(inputs)
	return ko_go_to_vault(inputs)
});